<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import minhead from '@/components/common/minHead/index.vue';
import xjgz from './xjgz/index.vue';
import ywlxgl from './ywlxgl/index.vue';
import { ywgz_query, ywlxgz_cxmr, ywlxgz_czyxj, ywlxgz_djxc, ywlxgz_scywgz } from '@/api/ywlxgz';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'ywlxzt_ywgz',
    props: {
        ztid: {
            type: Number,
            default: 0
        },
        ywzx: {
            type: String,
            default: '0'
        },
        formData: {
            type: Object,
            default: {}
        },
        pageType: {
            type: String,
            default: '',
        }
    },
    components: {
        minhead,//页面头标题
        xjgz,// 新建规则弹框
        ywlxgl// 业务类型管理弹框
    },
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            filterSearchlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            tableData: [{}],
            searchdiag: false,
            formdata: {},
            xjgzdialog: false,
            ywlxgldialog: false,
            ywzl: comMapping.$ywzx,
            sfqy: comMapping.$flag,
            minId: 0,
            maxId: 0,
            opType: 0,
            wikiType: "-1", // 页面类型， 0：新建 1：编辑
            dialogTitle: "",
            ruleData: {}
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        view(e) {
            // 查看点击事件
            if (this.pageType === "0") {
                // 业务类型规则页面
                this.ruleData = e;
                this.ruleData.setofbooksId = this.ztid;
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
            this.xjgzdialog = true;
            this.wikiType = "2"; // 编辑页面
            this.dialogTitle = "编辑业务规则";
        },
        edit(e) {
            // 编辑点击事件
            if (this.pageType === "0") {
                // 业务类型规则页面
                this.ruleData = e;
                this.ruleData.setofbooksId = this.ztid;
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
            this.xjgzdialog = true;
            this.wikiType = "1"; // 编辑页面
            this.dialogTitle = "编辑业务规则";
        },
        toUp(e, p) {
            // 上移点击事件
            if (p) {
                this.operationLevel("1", e);
            }
        },
        toDn(e, p) {
            // 下移点击事件
            if (p) {
                this.operationLevel("0", e);
            }
        },
        operationLevel(type, e){
            if (this.pageType === "0") {
                // 业务类型规则页面
                let params = {id: e.id, type: type, setOfBooksId: this.ztid, level: e.level};
                ywlxgz_czyxj(params).then(res => {
                    if (res.data.code !== "1") {
                        this.$message.error(res.data.msg);
                    } else {
                        this.$message.success("操作成功");
                        this.bsRuleQuery();
                    }
                })
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        createBsRule() {
            // 新建规则点击事件
            this.xjgzdialog = true;
            this.wikiType = "0"; // 新建页面
            this.dialogTitle = "新建业务规则";
            if (this.pageType === "0") {
                // 业务类型规则页面
                this.ruleData.setofbooksId = this.ztid;
                this.ruleData.bsType = this.formData.bsType;
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        bsTypeManage() {
            // 业务类型管理点击事件
            this.ywlxgldialog = true;
        },
        bsDelete() {
            // 删除点击事件
            if (this.pageType === "0") {
                // 业务类型规则页面
                let checkRow = this.$refs.tablebox.getSelectionval();
                let checkIds = []; // 选中的ID
                let enableIds = []; // 选中中启用的ID
                if (checkRow && checkRow.length > 0) {
                    this.$showConfirm({
                        message: '确认要删除吗?'
                    }).then((result) => {
                        if (result === 'confirm') {
                            checkIds = checkRow.map(item => item.id)
                            enableIds = checkRow.filter(item => item.enable && item.enable === "1").map(item => item.id);
                            let params = {ids:enableIds, setOfBooksId: this.ztid};
                            ywlxgz_cxmr(params).then(res => {
                                if (res.data.code !== '1') {
                                    // 存在其他的默认规则，直接删除
                                    this.deleteBsRule(checkIds);
                                } else {
                                    // 不存在
                                    this.$showConfirm({
                                        message: '删除后无启用中的业务规则,确认要删除吗?'
                                    }).then((result) => {
                                        if (result === 'confirm') {
                                            this.deleteBsRule(checkIds);
                                        }
                                    });
                                }
                            })
                        }
                    });
                } else {
                    this.$message.error("请选择需要删除的数据");
                }
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        deleteBsRule(checkIds) {
            ywlxgz_scywgz({ids: checkIds, setOfBooksId: this.ztid}).then(res => {
                if (res.data.code !== '1') {
                    this.$message.error(res.data.msg);
                } else {
                    this.$message.success(res.data.msg);
                    this.bsRuleQuery();
                }
            })
        },
        //初始化
        init() {
            this.bsRuleQuery();
        },
        //查询
        bsRuleQuery() {
            if (this.pageType === "0") {
                // 业务类型规则页面
                this.bsRuleLevelQuery();
                let params = JSON.parse(JSON.stringify(this.searchdata));
                params.setOfBooksId = this.ztid;
                params.current = this.pagination.pageNum;
                params.size = this.pagination.pageSize;
                params.sort = '';
                params.order = '';
                ywgz_query(params).then(res => {
                    if (res.data.code !== '1') {
                        this.$message.error(res.data.msg);
                    } else {
                        this.pagination.total = res.data.data.total;
                        this.tableData = res.data.data.records;
                    }
                });
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
            

        },
        bsRuleLevelQuery() {
            // 业务类型规则页面 规则查询
            let params = { booksId: this.ztid };
            ywlxgz_djxc(params).then(res => {
                if (res.data.code !== '1') {
                    this.$message.error(res.data.msg);
                } else {
                    if (res.data.data && res.data.data.length > 0) {
                        res.data.data.forEach(item => {
                            this.opType = item.type; // 只有一条这里会是2
                            if (item.type === 0) {
                                this.minId = item.id;
                            } else if (item.type === 1) {
                                this.maxId = item.id;
                            }
                        });
                    }
                }
            });
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.bsRuleQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.bsRuleQuery();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.bsRuleQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
        },
        forback() {
            this.$emit('forback', '');
        },
        xjgzclosediag() {
            if (this.pageType === "0") {
                // 业务类型规则页面
                this.wikiType = "-1";
                this.ruleData = {};
                this.bsRuleQuery();
            }
            this.xjgzdialog = false;
        },
        ywlxglclosediag() {
            this.ywlxgldialog = false;
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
